import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

export const InfoTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip
        placement="top"
        {...props}
        classes={{ popper: className }}
        slotProps={{
            popper: {
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [-2, 10],
                        },
                    },
                ],
            },
        }}
    />
))({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#C7D5C8',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 211,
        borderRadius: '5px',
        fontSize: '14px',
    },
});
